import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-in-wait',
  imports: [],
  templateUrl: './in-wait.component.html',
  styleUrl: './in-wait.component.scss',
})
export class InWaitComponent {
  onDownloadPlanDocs = input.required<() => void>();
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    return {
      claimType: this.claimType(),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
